module.exports = __webpack_public_path__ + "img/printer.10054f4e.svg";